<template>
  <div>
    <el-dialog
      show-close
      visible
      :width="!moqMaterialDisabled?'500px':'900px'"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $emit('close')"
      v-el-dialog-drag
    >
      <FabricTable
        v-if="moqMaterialDisabled"
        :amzSkuCodes="amzSkuCodes"
        :amzMoqCode="amzMoqCode"
      ></FabricTable>
      <div v-if="!moqMaterialDisabled">
        <el-form ref="form" :model="formData" size="mini" label-position="right" label-width="80px">
          <el-row :gutter="10">
            <el-col :span="20">
              <el-form-item :label="$l('form_label_moq') || '起订量'">
                <el-input-number
                  controls-position="right"
                  style="width: 100%"
                  size="mini"
                  :min="0"
                  :max="999999.9"
                  :step="0.01"
                  :precision="4"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  v-model="formData.moq"
                  v-el-inputnumber-default0
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer">
        <el-button size="small" @click="$emit('close')">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          v-if="!moqMaterialDisabled"
          size="small"
          @click="save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import FabricTable from './fabric-table/table'
export default {
  components: { FabricTable },
  props: {
    title: {
      type: String,
      default: '',
    },
    moqMaterialDisabled: {
      type: Boolean,
      default: false,
    },
    amzSkuCodes: { type: Array, default: () => [] },
    amzMoqCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { moq: 0 },
    }
  },
  methods: {
    save() {
      this.$api
        .ecomAmzMoqMaterialUpdateSkuMoqApi({
          amzSkuCodes: this.amzSkuCodes,
          amzMoqCode: this.amzMoqCode,
          ...this.formData,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
        })
    },
  },
}
</script>
